import * as React from 'react';

const Icons = {
  Back: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"/></svg>),
  Download: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>),
  Forward: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/></svg>),
  Heart: (<svg width="24" height="24" viewBox="0 0 24 24"><path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" /></svg>),
  Pause: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>),
  Play: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>),
  Star: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>),
  Tag: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"/></svg>),
  Transcript: (<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>),
  UnfoldLess: (<svg width="24" height="24" viewBox="0 0 24 24"><path d="M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z" /></svg>),
  UnfoldMore: (<svg width="24" height="24" viewBox="0 0 24 24"><path d="M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" /></svg>),
  Up: (<svg width="24" height="24" viewBox="0 0 24 24"><path d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" /></svg>),
}

interface IProps {
    disabled: boolean,
    onClick: () => void,
}

export const PlayButton: React.SFC<IProps & {playing: boolean}> = (props) => {
    return props.playing
        ? <button 
            disabled={props.disabled}
            onClick={props.onClick}
            className="pause-button"
            title="Pause">
            {Icons.Pause}
        </button>
        : <button 
            disabled={props.disabled}
            onClick={props.onClick}
            className="play-button"
            title="Play">
            {Icons.Play}
        </button>;
}

export const BackButton: React.SFC<IProps> = (props) => (
    <button 
        disabled={props.disabled}
        onClick={props.onClick}
        className="back-button"
        title="Back">
        {Icons.Back}
    </button>
)

export const ForwardButton: React.SFC<IProps> = (props) => (
    <button 
        disabled={props.disabled}
        onClick={props.onClick}
        className="back-button"
        title="Forward">
        {Icons.Forward}
    </button>
);


export const UnfoldButton: React.SFC<IProps & {expanded: boolean}> = (props) => (
    <button
        disabled={props.disabled}
        onClick={props.onClick}
        className="unfold-button"
        title="Expand">
        {props.expanded ? Icons.UnfoldLess : Icons.UnfoldMore}
    </button>
);

export const TranscriptButton: React.SFC<IProps> = (props) => (
  <button
    disabled={props.disabled}
    onClick={props.onClick}
    className="transcript-button"
    title="transcript">
    {Icons.Transcript}
  </button>
);

export const DownloadButton: React.SFC<IProps> = (props) => (
    <button
        disabled={props.disabled}
        onClick={props.onClick}
        className="download-button"
        title="Download">
        {Icons.Download}
    </button>
);



// WEBPACK FOOTER //
// ./src/components/Player/Buttons.tsx